document.addEventListener('DOMContentLoaded', function() {
  console.log('test');
  // const a = readCsv();
  // console.log({a});
})

// document.addEventListener("DOMContentLoaded", function() {
//   // CSVデータ (仮のデータ)
//   const shops = [
//       { name: "ジェイアール名古屋タカシマヤ", address: "名古屋市中村区名駅一丁目1番4号", phone: "052-566-8447" },
//       { name: "ワイ・ヨットストア 麻布台ヒルズ店", address: "港区麻布台1-3-1 麻布台ヒルズ タワープラザ4階", phone: "03-6426-5818" },
//       { name: "ラ・クッチーナ・フェリ－チェ 渋谷店", address: "渋谷区渋谷2-21-1 渋谷ヒカリエShinQs5階", phone: "03-6427-1604" }
//   ];

//   const tableBody = document.getElementById("shop-table-body");

//   shops.forEach(shop => {
//       const row = document.createElement("tr");
//       row.innerHTML = `
//           <td>${shop.name}</td>
//           <td>${shop.address}</td>
//           <td>${shop.phone}</td>
//           <td><a href="https://www.google.com/maps/search/?q=${encodeURIComponent(shop.address)}" target="_blank">地図</a></td>
//       `;
//       tableBody.appendChild(row);
//   });
// });

/**
 * CSVファイルの読み込み
 * Arrayにする
 * @return {Array} CSVを配列に変換したデータ
 */
// function readCsv() {
//   // csvファイルを取得
//   let csv = new XMLHttpRequest();

//   // csvファイルへのパス
//   csv.open("GET", "https://cdn.shopify.com/s/files/1/0594/1493/7786/files/shoplist_ichendorf.csv?v=1738677103", false);

//   // csvファイル読み込み失敗時のエラー対応
//   try {
//     csv.send(null);
//   } catch (err) {
//     console.log(err);
//   }

//   // 配列を定義
//   let csvArray = [];

//   // 改行ごとに配列化
//   let lines = csv.responseText.split(/\r\n|\n/);

//   // 1行ごとに処理
//   for (let i = 0; i < lines.length; ++i) {
//     let cells = lines[i].split(",");
//     if (cells.length != 1) {
//       csvArray.push(cells);
//     }
//   }

//   return csvArray;
// }